/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ILdsStoreLocatorData } from './lds-store-locator.data';
import { ILdsStoreLocatorProps } from './lds-store-locator.props.autogenerated';

export interface ILdsStoreProps extends ILdsStoreLocatorProps<ILdsStoreLocatorData> {}

/**
 *
 * LdsContactUs Component
 * @extends {React.PureComponent<ILdsFooterProps<ILdsFooterData>>}
 */
class LdsContactUs extends React.PureComponent<ILdsStoreLocatorProps<ILdsStoreLocatorData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default LdsContactUs;
